import React, { useEffect } from "react";
import "./AboutUsBottomSheet.css";

const AboutUsBottomSheet = ({ isOpen, onClose }) => {
  // Prevent scrolling on body when bottom sheet is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  return (
    <>
      <div
        className={`about-overlay ${isOpen ? "show" : ""}`}
        onClick={onClose}
      ></div>
      <div className={`about-bottom-sheet ${isOpen ? "show" : ""}`}>
        <div className="about-sheet-header">
          <div className="about-drag-handle" onClick={onClose}></div>
          <button className="about-close-btn" onClick={onClose}>
            <i className="fas fa-times"></i>
          </button>
        </div>

        <div className="about-sheet-content">
          {/* Hero Section */}
          <div className="about-hero">
            <img
              src="https://lh3.googleusercontent.com/aida-public/AB6AXuDScCn24IcQLnrljHNRbt6FWa5J3IyDM2Te7mFx58RhrhNSSq1heTrQVGOcjhfRs4nb368kgz8qFrI1tUmqtwKJ0T8WCHSpPOWvO5prcr5FOgohBfD044dDdIzN8gU9tBmWgfaIUE8mHKZ7syh7EEvnst7oEUJRYFblVonMxMp3iyPgfhAnQogJj1lc9_et3THXQWp-fpJ6elONixSWAGpCzKkuKLxPCrdNXPISIkB3EjpB0zDWq_Bvveivzpp6FNnBQWYi9GZlJXhA"
              alt="Fresh vegetables"
            />
            <div className="about-hero-overlay"></div>
            <div className="about-hero-content">
              <h1 className="about-hero-title about-font-heading">
                Bringing Quality Groceries to Your Home{" "}
              </h1>
              <p className="about-hero-subtitle">
                At Aaroh Food Ltd, we believe that good food starts with good
                ingredients. For over a decade, we’ve been serving local
                communities through our UK retail store—now expanded into a
                seamless online shopping experienceFrom everyday essentials to
                authentic global ingredients, we’re here to make your grocery
                shopping simple, fresh, and dependable. .
              </p>
            </div>
          </div>

          {/* Mission Section */}
          <div className="about-section">
            <div className="about-grid-2">
              <div>
                <h2 className="about-heading about-font-heading about-text-primary">
                  <i className="fas fa-leaf"></i> Our Mission
                </h2>
                <p className="about-paragraph about-text-muted">
                  Our goal is straightforward: to provide fresh, high-quality
                  groceries at fair prices, while making shopping effortless for
                  families, students, and busy professionals. We work closely
                  with trusted suppliers, local distributors, and
                  quality-focused producers to ensure you get the best
                  products—from spices and grains to fresh produce and kitchen
                  staples.
                </p>
                <p className="about-paragraph about-text-muted">
                  Whether you're stocking up your family pantry or sourcing
                  ingredients for your restaurant, we’re committed to delivering
                  quality you can trust.
                </p>
              </div>
              <div className="about-card">
                <div className="about-icon-box">
                  <i className="fas fa-seedling"></i>
                </div>
                <h3
                  className="about-font-heading about-text-primary"
                  style={{ fontSize: "24px", marginBottom: "15px" }}
                >
                  Sustainability First
                </h3>
                <p className="about-text-muted" style={{ lineHeight: "1.6" }}>
                  Our packaging choices and logistic partners reflect our effort
                  to reduce waste and support responsible practices.
                </p>
                <ul className="about-list about-text-muted">
                  <li>
                    <i className="fas fa-check-circle"></i> Plastic-free
                    packaging solutions
                  </li>
                  <li>
                    <i className="fas fa-check-circle"></i> Zero-waste
                    fulfillment centers
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Values Section */}
          <div className="about-values-bg">
            <div className="about-section">
              <h2
                className="about-heading about-font-heading about-text-primary"
                style={{ justifyContent: "center", marginBottom: "10px" }}
              >
                What We Stand For
              </h2>
              <div className="about-values-grid">
                <div className="about-value-item">
                  <div className="about-value-icon">
                    <i className="fas fa-stopwatch"></i>
                  </div>
                  <h3 className="about-value-title about-font-heading">
                    Freshness
                  </h3>
                  <p
                    className="about-text-muted"
                    style={{ fontSize: "14px", lineHeight: "1.6" }}
                  >
                    We focus on products that arrive on time, in great
                    condition, and ready for your kitchen.
                  </p>
                </div>
                <div className="about-value-item">
                  <div className="about-value-icon">
                    <i className="fas fa-certificate"></i>
                  </div>
                  <h3 className="about-value-title about-font-heading">
                    Quality
                  </h3>
                  <p
                    className="about-text-muted"
                    style={{ fontSize: "14px", lineHeight: "1.6" }}
                  >
                    Every item is sourced with care and selected for taste,
                    authenticity, and reliability.
                  </p>
                </div>
                <div className="about-value-item">
                  <div className="about-value-icon">
                    <i className="fas fa-tree"></i>
                  </div>
                  <h3 className="about-value-title about-font-heading">
                    Sustainability
                  </h3>
                  <p
                    className="about-text-muted"
                    style={{ fontSize: "14px", lineHeight: "1.6" }}
                  >
                    Our packaging choices and logistic partners reflect our
                    effort to reduce waste and support responsible practices.
                  </p>
                </div>
                <div className="about-value-item">
                  <div className="about-value-icon">
                    <i className="fas fa-handshake"></i>
                  </div>
                  <h3 className="about-value-title about-font-heading">
                    Trust
                  </h3>
                  <p
                    className="about-text-muted"
                    style={{ fontSize: "14px", lineHeight: "1.6" }}
                  >
                    Clear information, honest policies, and a dependable
                    service—every step of the way.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Story Section */}
          <div className="about-section">
            <div className="about-grid-2">
              <div className="story-img-col">
                <img
                  src="https://lh3.googleusercontent.com/aida-public/AB6AXuDvM0XRl3Hx_yG6_sY2mQ1uItWWCAdtfSYomEwUTFu5dkq_I4Of5JyhcJU_TvU_ehl6MEiqyXch5EkUp0ug6JfmJcFk-dPPGALUVBnuzxNncALavlz0d0WVAQdXCg0swfDVszINueagIAg7S4Osvk1vUCRGgf4anzpKqfi_OvKDJDea1Im9k2kngctaMHfv4_RHLayo3_kDSfz6FatraaKNOQBXDL7AIfnDlbx_9Golm99rWzE0zr4cIu4_WXyh1DMQdN0YucLKrQJQ"
                  alt="Farmers in fields"
                  className="about-story-img"
                />
              </div>
              <div className="story-text-col">
                <h2 className="about-heading about-font-heading about-text-primary">
                  Our Story
                </h2>
                <p className="about-paragraph about-text-muted">
                  Aaroh Food Ltd began as a small neighbourhood grocery shop,
                  serving households with the ingredients they grew up with and
                  the everyday staples they rely on. Over the years, we earned
                  our customers’ trust by focusing on quality, fair prices, and
                  friendly service.
                </p>
                <p className="about-paragraph about-text-muted">
                  In 2018, FreshRoot was born in a small community garage with
                  just three local farmers and a dream to reconnect people with
                  their food. We spent months driving through the countryside,
                  meeting the families who dedicate their lives to the land.
                </p>
                <p className="about-paragraph about-text-muted">
                  As lifestyles changed, we expanded online—bringing the same
                  commitment to quality into a faster, more convenient shopping
                  experience. Today, we proudly serve thousands of families,
                  students, and restaurants across the UK. But our core remains
                  unchanged: good food, good value, and good service—always.
                </p>
              </div>
            </div>
          </div>

          {/* CTA Section */}
          <div className="about-cta-container">
            <div className="about-cta-box">
              <h2 className="about-cta-title about-font-heading">
                Explore a simpler way to shop. Fresh groceries, authentic
                flavours, and everyday essentials—delivered to your door.
              </h2>
              <button className="about-btn" onClick={onClose}>
                Continue Shopping
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutUsBottomSheet;
